import axios from "axios";

export const state = {
    radiologypatients: [],
};

export const getters = {
    radiologypatients: state => state.radiologypatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.radiologypatients = newValue
    },
};

export const actions = {
    fetchRadiologyPatients({ commit }) {
        axios.get('/radiologypatients').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
    filterRadiologyPatients({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterradiologypatients";
        axios.post(url, formData).then((response) => {
            commit('setPatients', response.data.visits)
        })
    },
};
